import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from '../../../../api/';
import Modal from "./Modal.js";
import ParadigmaTable from "../../../../components/ParadigmaTable/";
import FormatFunctions from "../../../../functions/functions";

class Bitacoras extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Actividad",
                    id: "Actividad",
                    accessor: "Actividad",
                    show: true,
                    filterable: true,
                },

                {
                    Header: "Fecha",
                    id: "FUA",
                    className: "text-center",
                    accessor: d => FormatFunctions.FormatDate(d.FUA),
                    filterable: true,
                    width: 200,
                    show: true,
                },
            ]
        };
    }

    static propTypes = {
        additionalFields: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            onGet: PropTypes.string.isRequired, // (data: data que llega del servidor) => objeto: { key: value } lo que retorna se setea en el estado
            onPost : PropTypes.string.isRequired, // (data: data del estado que se envia al servidor) => objeto: { key: value } lo que se envia al servidor
            Input: PropTypes.func.isRequired, // (state, setThis, disabled, error) => <Input />
        })),
    }

    render() {
        const { data, pages, loading } = this.state;
        const { additionalFields } = this.props;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                       detail: true,
                       component: (props) => <Modal {...props} action="DETAIL" additionalFields={additionalFields} />,
                       permission:"ecommerce_config_bitacora_view"
                    },
                ]}
                apiUrl={api.gestion.core.bitacoras}
                columns={this.state.columns}
                title={"Actividades"}
            />
        );
    }
}

export default Bitacoras;



// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Bitacoras/Bitacoras.js